enum Targets {
  Recruitment = 'recruitment',
  Security = 'security',
}

export default Targets;
